import React from "react";
import { LoadingSpinner } from "../../design-system";

const LoadingPage = ({ size = "xl" }) => {
  return (
    <div className="flex items-center justify-center h-screen">
      <LoadingSpinner size={size} color="primary" />
    </div>
  );
};

export default LoadingPage;
